export enum MenuMode {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
